<template>
  <div class="sticky-edge">
      <img :src="image" :class="'edge-' + edge"/>
  </div>
</template>

<script>
export default {
    props: ['element', 'image', 'edge'],
    methods: {
        
    }
}
</script>

<style lang="scss" scoped>
    .sticky-edge {
        display: flex;
        .edge-bottom {
            
        }
    }
</style>